import dayjs, { Dayjs } from 'dayjs'
import moment, { Moment } from 'moment'

export const getStartOfDay = (date: Date) => new Date(new Date(date).setHours(0, 0, 0, 0))
export const getEndOfDay = (date: Date) => new Date(new Date(date).setHours(23, 59, 59, 999))

export const getEndOfDayWithoutTimezone = (date: Date) => {
  return dayjs(date)
    .hour(23)
    .minute(59)
    .second(59)
    .millisecond(999)
    .format('YYYY-MM-DD HH:mm:ss.SSS')
}

export const getMonthStartEnd = (date: Date) => {
  const monthStart = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0)
  const monthEnd = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59)
  return { monthStart, monthEnd }
}

export const formatDateLongMonth = (date: string) => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }
  return new Intl.DateTimeFormat(undefined, options).format(new Date(date))
}

export const convertDayjsToMoment = (date: Dayjs | null): Moment | null => {
  return date ? moment(date.toDate()) : null
}

export const convertMomentToDayjs = (date: Moment | null): Dayjs | null => {
  return date ? dayjs(date.toDate()) : null
}
